import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingHero, LandingParagraph} from '@tempo/landing';
import {Box} from '@tempo/core';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {StarIcon} from '@tempo/icons';
import {useAuthLink} from '@app/hooks/use-link';

export const HeroBlock: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['reviews', 'common']});
	const {getRegistrationLink} = useAuthLink();
	return (
		<LandingHero minH="500px" position="relative" isContained>
			<LandingHeading as="h1">
				{t('reviewslandingpage_title_whatpeoplethinkofus_standalone-web')}
			</LandingHeading>
			<Box display="flex">
				<Box display="flex" alignItems="baseline" fontSize="55px">
					4,7
					<Box as="span" fontSize="24px">
						/5
					</Box>
				</Box>
				<Box pl="10px">
					<StarIcon size="medium" boxSize={10} color="white" mt={22} />
				</Box>
			</Box>

			<LandingParagraph>
				{t('reviewslandingpage_text_averagerating_standalone-web', {
					sprintf: [`3`],
					count: 3,
				})}
			</LandingParagraph>
			<LandingButtonLink
				tracking={{
					eventaction: 'signup',
					eventcategory: 'review',
				}}
				isMain
				target="_blank"
				href={getRegistrationLink()}
			>
				{t('generic_action_signupforfree_standalone-web')}
			</LandingButtonLink>
		</LandingHero>
	);
};
